<template>
  <section
    class="max-w-6xl mx-auto mt-6 min-h-8 px-4 sm:px-6 md:px-8 lg:px-10 pb-10"
  >
    <div class="flex justify-center mt-2 mb-4">
      <img
        :src="require('@/assets/images/logo-header.webp')"
        alt="Logo"
        class="h-16 sm:h-24 w-auto"
      />
    </div>
    <router-link
      v-if="$route.name === 'payment-center-payment-tracking'"
      to="/payment/center/home"
      class="inline-flex items-center gap-2 rounded-lg border border-zinc-200 bg-white px-4 py-2 text-sm font-medium text-zinc-700 shadow-sm transition-all duration-200 hover:border-blue-500 hover:bg-blue-50 hover:text-blue-600 hover:shadow"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="h-5 w-5"
      >
        <path
          d="M19 21H5C4.44772 21 4 20.5523 4 20V11L1 11L11.3273 1.6115C11.7087 1.26475 12.2913 1.26475 12.6727 1.6115L23 11L20 11V20C20 20.5523 19.5523 21 19 21ZM6 19H18V9.15745L12 3.7029L6 9.15745V19ZM8 15H16V17H8V15Z"
        />
      </svg>

      <span>Back to Home</span>
    </router-link>
    <div v-if="isRenderLoad">
      <!-- Tracking Header -->
      <div class="flex justify-between items-center">
        <div class="flex flex-col gap-2">
          <h2 class="text-sm font-normal text-zinc-600">IWC Card Number</h2>
          <h3 class="text-lg font-bold text-secondary">
            {{ applicationDetails.transactionnumber }}
          </h3>
        </div>
        <div
          class="hidden sm:block my-6 rounded-lg px-12 py-3 text-sm border"
          :class="{
            'bg-blue-100 text-blue-700 border-blue-300':
              applicationStatus === 'Assessment',
            'bg-orange-100 text-orange-700 border-orange-300':
              applicationStatus === 'Pending Documents',
            'bg-green-100 text-green-800 border-green-300':
              applicationStatus === 'Approved',
            'bg-red-100 text-red-700 border-red-300':
              applicationStatus === 'Declined',
            'bg-yellow-100 text-yellow-700 border-yellow-300':
              applicationStatus === 'Payment Preparation',
            'bg-green-100 text-green-700 border-green-300':
              applicationStatus === 'Active',
          }"
        >
          {{ applicationStatus }}
        </div>
      </div>

      <div class="mb-6 mt-6">
        <div class="grid grid-cols-[8rem_1rem_1fr] gap-y-2 text-sm">
          <span class="font-semibold text-secondary">Name</span>
          <span>:</span>
          <span class="uppercase">{{ applicationDetails.membername }}</span>

          <span class="font-semibold text-secondary">School Name</span>
          <span>:</span>
          <span class="uppercase">{{ applicationDetails.company }}</span>

          <span class="font-semibold text-secondary">Effectivity</span>
          <span>:</span>
          <span class="uppercase">{{ applicationDetails.effectivity }}</span>
        </div>
      </div>
    </div>
    <hr />
    <router-view />
  </section>
</template>

<script>
import { inject, onMounted, ref, computed } from "vue";

export default {
  setup() {
    const router = inject("$router");
    const moment = inject("$moment");

    const isRenderLoad = ref(false);

    const applicationDetails = ref({
      transactionnumber: "IWC-A-00072",
      membername: "JUAN DELA CRUZ",
      company: "ABC Elementary School",
      effectivity: "July 18, 2025",

      approvaltype: "Approved",
      paymentstatus: "Active",

      reimbursableamount: 5000,

      paymentreference: "PAY-123456",

      renderstartdate: "2026-07-01",
      graceperiod: 7,

      updatedAt: "2026-07-03T10:30:00",

      AttachmentFiles: [
        {
          particular: "Official Receipt",
        },
        {
          particular: "Medical Certificate",
        },
      ],

      adminlogs: [
        {
          status: "New Application",
          createdAt: "2026-07-01T09:00:00",
        },
        {
          status: "Assessment",
          createdAt: "2026-07-01T10:30:00",
        },
        {
          status: "Approved",
          createdAt: "2026-07-02T08:45:00",
        },
      ],
    });

    onMounted(() => {
      isRenderLoad.value = true;
    });

    const dateFormatHandler = (val) => {
      return moment(val).format("LLL");
    };

    const descriptionComposition = (val) => {
      const amount = applicationDetails.value.reimbursableamount || 0;

      const GuaranteedAmount = `₱${amount.toLocaleString("en-PH", {
        minimumFractionDigits: 2,
      })}`;

      const renderStart = applicationDetails.value.renderstartdate;

      const renderEnd = moment(renderStart)
        .add(applicationDetails.value.graceperiod, "days")
        .format("LL");

      switch (val) {
        case "New Application":
          return "We have already received and will review your reimbursement application soon.";

        case "Assessment":
          return "Your reimbursement application is being reviewed.";

        case "Pending Documents":
          return `
            Your reimbursement application has been reviewed and found to have incomplete supporting document(s). Please submit the required documents by
            <span class="font-bold text-stone-900">${renderEnd}</span>.
            <p class="mt-3 font-semibold">Pending Document(s):</p>
            <ul class="list-disc list-inside">
              ${applicationDetails.value.AttachmentFiles.map(
                (item) => `<li>${item.particular}</li>`
              ).join("")}
            </ul>
          `;

        case "Approved":
          return `The evaluation process for your reimbursement application is complete and has been approved for the amount of <strong>${GuaranteedAmount}</strong>. Payment preparation is now in progress.`;

        case "Payment Preparation":
          return "Your application has been submitted for payment and will be processed shortly.";

        case "Payment Released":
          return `Your application has been completed, and the payment has been deposited to your account.`;

        default:
          return "We regret to inform you that your reimbursement application has been declined.";
      }
    };

    const descriptionTitle = (val) => {
      switch (val) {
        case "New Application":
          return "Application Request Received";

        case "Assessment":
          return "For Assessment";

        case "Pending Documents":
          return "For Completion of Documents";

        case "Approved":
          return "Approval Granted";

        case "Payment Preparation":
          return "Payment Preparation";

        case "Payment Released":
          return "Payment Released";

        default:
          return "Declined";
      }
    };

    const applicationStatus = computed(() => {
      const status =
        applicationDetails.value.paymentstatus ||
        applicationDetails.value.approvaltype;

      return status === "Pending" ? "Payment Preparation" : status;
    });

    const goBack = () => {
      router.back();
    };

    return {
      applicationDetails,
      dateFormatHandler,
      descriptionComposition,
      descriptionTitle,
      applicationStatus,
      isRenderLoad,
      goBack,
    };
  },
};
</script>
<style scoped>
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  75%,
  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
}

.loader {
  animation: rotate 1s linear infinite;
}
.animate-rotate {
  animation: rotate 1s linear infinite;
}
.animate-prixClipFix {
  animation: prixClipFix 2s linear infinite;
}
</style>
